import React from 'react';
import { motion } from 'framer-motion';
export function FloatingElements() {
  // Matrix-style rain characters
  const characters = '010101TOXICALERT⚠️🚩';
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-2388">
      {/* Glitch Overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')] mix-blend-overlay" data-id="element-2389"></div>

      {/* Random Code Snippets */}
      {[...Array(5)].map((_, i) => <motion.div key={`code-${i}`} initial={{
      opacity: 0,
      y: -100
    }} animate={{
      opacity: [0, 0.4, 0],
      y: ['0%', '100%']
    }} transition={{
      duration: 5 + Math.random() * 5,
      repeat: Infinity,
      delay: Math.random() * 5,
      ease: 'linear'
    }} className="absolute text-[#FF0000] font-mono text-xs opacity-20 writing-vertical-rl" style={{
      left: `${10 + Math.random() * 80}%`,
      fontSize: `${10 + Math.random() * 10}px`
    }} data-id="element-2390">
          {Array.from({
        length: 20
      }).map(() => characters[Math.floor(Math.random() * characters.length)]).join('\n')}
        </motion.div>)}

      {/* Floating Cyber Shapes */}
      <motion.div animate={{
      rotate: [0, 360],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute top-20 left-10 w-64 h-64 border border-[#FF0000]/10 rounded-full border-dashed opacity-20" data-id="element-2391" />

      <motion.div animate={{
      rotate: [360, 0],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 25,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute bottom-40 right-10 w-96 h-96 border border-[#FFD700]/5 rounded-full border-dotted opacity-20" data-id="element-2392" />

      {/* Glowing Orbs */}
      <div className="absolute top-1/4 right-1/4 w-32 h-32 bg-[#FF0000] rounded-full blur-[100px] opacity-10 animate-pulse" data-id="element-2393" />
      <div className="absolute bottom-1/4 left-1/4 w-40 h-40 bg-[#FFD700] rounded-full blur-[120px] opacity-5 animate-pulse" data-id="element-2394" />
    </div>;
}